import { render, staticRenderFns } from "./RafflePrizesComponentView.vue?vue&type=template&id=f8c0f140&scoped=true"
import script from "./RafflePrizesComponentView.vue?vue&type=script&lang=js"
export * from "./RafflePrizesComponentView.vue?vue&type=script&lang=js"
import style0 from "./RafflePrizesComponentView.vue?vue&type=style&index=0&id=f8c0f140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c0f140",
  null
  
)

export default component.exports